import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39a247ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=39a247ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a247ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a247ca')) {
      api.createRecord('39a247ca', component.options)
    } else {
      api.reload('39a247ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39a247ca&scoped=true", function () {
      api.rerender('39a247ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/viewDesign/index.vue"
export default component.exports